import * as React from "react";
import ReactDOM from "react-dom";
import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartValueAxis,
    ChartValueAxisItem,
    ChartTitle,
    ChartLegend,
    exportVisual,
    ChartSeriesDefaults,
} from "@progress/kendo-react-charts";
import configData from "../../config.json";
import { GetSession, GetToken } from "../../components/Session";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { exportPDF } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import { GetCloudLogin } from "../../WeighBridge/Helpers";
import "hammerjs";
import { filterBy } from "@progress/kendo-data-query";

const cardStyle3D = {
    borderRadius: "10px",
    boxShadow:
        "0 6px 15px rgba(0, 0, 0, 0.25), inset 0 -3px 6px rgba(255, 255, 255, 0.3)",
    backgroundColor: "#fff",
};

const buttonStaticStyle = {
    borderRadius: "6px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    cursor: "pointer",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    padding: "6px 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

const modalStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 10000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
    },
    content: {
        backgroundColor: "white",
        borderRadius: "8px",
        width: "95vw",
        height: "95vh",
        padding: "20px",
        position: "relative",
        boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        perspective: "1000px",
    },
    closeBtnTopRight: {
        position: "absolute",
        top: "10px",
        right: "15px",
        fontSize: "28px",
        border: "none",
        background: "none",
        cursor: "pointer",
        color: "#333",
    },
    closeBtnBottom: {
        marginTop: "auto",
        alignSelf: "center",
        padding: "10px 25px",
        fontSize: "16px",
        borderRadius: "5px",
        border: "1px solid #333",
        background: "white",
        cursor: "pointer",
        color: "#333",
        transition: "background-color 0.2s ease",
    },
};

const PerformanceTrend = () => {
    const [panes, setPanes] = React.useState([{ size: "15%", collapsible: true }, {}]);
    const onChange = (event) => setPanes(event.newState);

    const [categories, setCategories] = React.useState(null);
    const [sales, setSales] = React.useState(null);
    const [productPerformance, setProductPerformance] = React.useState(null);
    const [pieData, setPieData] = React.useState(null);
    const [accumulated, setAccumulated] = React.useState(null);
    const [siteHeading, setSiteHeading] = React.useState("Site Performance");
    const [modalChart, setModalChart] = React.useState(null);

    const saleRef = React.useRef(null);
    const productRef = React.useRef(null);
    const totalRef = React.useRef(null);
    const siteRef = React.useRef(null);

    const [labels, setLabels] = React.useState(["1", "2"]);
    const [title, setTitle] = React.useState("");
    const [salesYAxis, setSalesYAxis] = React.useState("");
    const [productYAxis, setProductYAxis] = React.useState("");
    const [accYAxis, setAccYAxis] = React.useState("");

    // Filter states
    const [loadTypes, setLoadTypes] = React.useState([]);
    const [loadType, setLoadType] = React.useState(JSON.parse(localStorage.getItem("DashboardLoadTypes")) || []);
    const [vehicleTypes, setVehicleTypes] = React.useState([]);
    const [vehicleType, setVehicleType] = React.useState(JSON.parse(localStorage.getItem("DashboardVehicleTypes")) || []);
    const [jobs, setJobs] = React.useState([]);
    const [job, setJob] = React.useState(JSON.parse(localStorage.getItem("DashboardJobs")) || []);
    const [customers, setCustomers] = React.useState([]);
    const [customer, setCustomer] = React.useState(JSON.parse(localStorage.getItem("DashboardCustomers")) || []);
    const [sources, setSources] = React.useState([]);
    const [source, setSource] = React.useState(JSON.parse(localStorage.getItem("DashboardSources")) || []);
    const [destinations, setDestinations] = React.useState([]);
    const [destination, setDestination] = React.useState(JSON.parse(localStorage.getItem("DashboardDestinations")) || []);
    const [sites, setSites] = React.useState([]);
    const [site, setSite] = React.useState(JSON.parse(localStorage.getItem("DashboardSites")) || []);
    const [products, setProducts] = React.useState([]);
    const [product, setProduct] = React.useState(JSON.parse(localStorage.getItem("DashboardProducts")) || []);
    const [directions, setDirections] = React.useState([]);
    const [direction, setDirection] = React.useState(JSON.parse(localStorage.getItem("DashboardDirections")) || []);
    const [productdata, setproductData] = React.useState();
    const [customerdata, setcustomerData] = React.useState();
    const [jobdata, setjobData] = React.useState();
    const [truckconfdata, settruckconfData] = React.useState();
    const [destdata, setdestData] = React.useState();
    const [srcdata, setsrcData] = React.useState();

    const onImageExportClick = (e) => {
        const chartName = e.currentTarget.name;
        let chartVisual = null;

        if (chartName === "sales") chartVisual = saleRef.current && exportVisual(saleRef.current);
        else if (chartName === "product") chartVisual = productRef.current && exportVisual(productRef.current);
        else if (chartName === "total") chartVisual = totalRef.current && exportVisual(totalRef.current);
        else chartVisual = siteRef.current && exportVisual(siteRef.current);

        if (chartVisual) {
            exportPDF(chartVisual, {
                paperSize: "A4",
                landscape: true,
            }).then((dataURI) => saveAs(dataURI, "Weekly Performance.pdf"));
        }
    };

    const UpdateData = (
        lt = [],
        src = [],
        dest = [],
        st = [],
        jb = [],
        cust = [],
        prod = [],
        vt = [],
        dir = []
    ) => {
        const params = {
            FromDate: "2000-01-01T00:00:00Z",
            ToDate: "2050-01-01T00:00:00Z",
            LoadType: lt.join(","),
            Source: src.map((v) => v.id).join(","),
            Destination: dest.map((v) => v.id).join(","),
            Site: st.map((v) => v.id).join(","),
            Job: jb.map((v) => v.id).join(","),
            Customer: cust.map((v) => v.id).join(","),
            Product: prod.map((v) => v.id).join(","),
            VehicleType: vt.map((v) => v.id).join(","),
            Direction: dir.join(","),
        };

        GetCloudLogin((cred) => {
            const token = cred === "" ? cred : cred.token;
            const sess = GetSession();
            let baseUrl = token && token !== "" ? sess.CloudURL : configData.SERVER_URL;
            const timeOffset = new Date().getTimezoneOffset() / 60;
            baseUrl += `apiV7/dashboard/getperformancetrends?prm=${encodeURI(
                JSON.stringify(params)
            )}&offset=${timeOffset}&siteId=${sess.SiteID}`;

            fetch(baseUrl, {
                method: "GET",
                accept: "application/json",
                headers: { Authorization: "Bearer " + (token || GetToken()) },
            })
                .then((response) => response.json())
                .then((d) => {
                    setSales(d.sales);
                    setProductPerformance(d.productPerformance);
                    setAccumulated(d.accumulated);
                    setPieData(d.pieData);
                    setCategories(d.productNames);
                    setLabels(d.labels);
                    if (d.sites === 1) setSiteHeading("Product Share");
                    setTitle(d.title);
                    setSalesYAxis(d.salesY);
                    setProductYAxis(d.productY);
                    setAccYAxis(d.accY);
                });
        });
    };

    React.useEffect(() => {
        UpdateData();

        fetch(configData.SERVER_URL + "apiv7/options", {
            method: "GET",
            accept: "application/json",
            headers: { Authorization: "Bearer " + GetToken() },
        })
            .then((response) => response.json())
            .then((d) => {
                setLoadTypes(d.loadTypes.filter((item) => item !== "First"));
                setVehicleTypes(d.vehicles);
                setJobs(d.jobs);
                setjobData(d.jobs);
                setCustomers(d.customers);
                setcustomerData(d.customers);
                setSources(d.sources);
                setsrcData(d.sources);
                setDestinations(d.destinations);
                setdestData(d.destinations);
                setSites(d.sites);
                setProducts(d.products);
                setproductData(d.products);
                setDirections(d.directions);
            });
    }, []);

    // Filter onChange handlers
    const changeHandlers = {
        loadType: (e) => {
            setLoadType(e.target.value);
            localStorage.setItem("DashboardLoadTypes", JSON.stringify(e.target.value));
        },
        vehicleType: (e) => {
            setVehicleType(e.target.value);
            localStorage.setItem("DashboardVehicleTypes", JSON.stringify(e.target.value));
        },
        job: (e) => {
            setJob(e.target.value);
            localStorage.setItem("DashboardJobs", JSON.stringify(e.target.value));
        },
        customer: (e) => {
            setCustomer(e.target.value);
            localStorage.setItem("DashboardCustomers", JSON.stringify(e.target.value));
        },
        source: (e) => {
            setSource(e.target.value);
            localStorage.setItem("DashboardSources", JSON.stringify(e.target.value));
        },
        destination: (e) => {
            setDestination(e.target.value);
            localStorage.setItem("DashboardDestinations", JSON.stringify(e.target.value));
        },
        site: (e) => {
            setSite(e.target.value);
            localStorage.setItem("DashboardSites", JSON.stringify(e.target.value));
        },
        product: (e) => {
            setProduct(e.target.value);
            localStorage.setItem("DashboardProducts", JSON.stringify(e.target.value));
        },
        direction: (e) => {
            setDirection(e.target.value);
            localStorage.setItem("DashboardDirections", JSON.stringify(e.target.value));
        },
    };

    const DoSearch = () => {
        UpdateData(loadType, source, destination, site, job, customer, product, vehicleType, direction);
    };

    const ClearSearch = () => {
        setLoadType([]);
        setVehicleType([]);
        setJob([]);
        setCustomer([]);
        setSource([]);
        setDestination([]);
        setSite([]);
        setProduct([]);
        setDirection([]);

        localStorage.setItem("DashboardLoadTypes", null);
        localStorage.setItem("DashboardVehicleTypes", null);
        localStorage.setItem("DashboardJobs", null);
        localStorage.setItem("DashboardCustomers", null);
        localStorage.setItem("DashboardSources", null);
        localStorage.setItem("DashboardDestinations", null);
        localStorage.setItem("DashboardSites", null);
        localStorage.setItem("DashboardProducts", null);
        localStorage.setItem("DashboardDirections", null);

        UpdateData([], [], [], [], [], [], [], [], []);
    };

    const ExportZoomButton = ({ name, onClick, iconClass, ariaLabel }) => (
        <button
            type="button"
            name={name}
            onClick={onClick}
            aria-label={ariaLabel}
            style={buttonStaticStyle}
            className="k-button k-button-icon"
        >
            <i className={`fa ${iconClass}`} aria-hidden="true" />
        </button>
    );

    const ButtonsGroup = ({ exportName, onExportClick, onZoomClick }) => (
        <div
            style={{
                display: "flex",
                gap: "8px",
                justifyContent: "flex-end",
                marginBottom: 8,
            }}
        >
            <ExportZoomButton
                name={exportName}
                onClick={onExportClick}
                iconClass="fa-download"
                ariaLabel="Export as PDF"
            />
            <ExportZoomButton
                onClick={onZoomClick}
                iconClass="fa-expand"
                ariaLabel="Expand Chart"
            />
        </div>
    );

    const filterproductData = (filter) => {
        const productdata = products.slice();
        return filterBy(productdata, filter);
    };
    const filterprodChange = (event) => {
        setproductData(filterproductData(event.filter));
    };

    const filterjobtData = (filter) => {
        const jobdata = jobs.slice();
        return filterBy(jobdata, filter);
    };
    const filterjobChange = (event) => {
        setjobData(filterjobtData(event.filter));
    };

    const filtercustomerData = (filter) => {
        const customerdata = customers.slice();
        return filterBy(customerdata, filter);
    };
    const filtercustChange = (event) => {
        setcustomerData(filtercustomerData(event.filter));
    };
    const filterdesData = (filter) => {
        const desdata = destinations.slice();
        return filterBy(desdata, filter);
    };
    const filterdestChange = (event) => {
        setdestData(filterdesData(event.filter));
    };

    const filtersrcData = (filter) => {
        const srcdata = sources.slice();
        return filterBy(srcdata, filter);
    };
    const filtersrcChange = (event) => {
        setsrcData(filtersrcData(event.filter));
    };


    const renderModalChart = () => {
        if (!modalChart) return null;

        const commonProps = {
            style: {
                height: "85vh",
                width: "100%",
                filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.2))",
                borderRadius: "10px",
            },
        };

        switch (modalChart) {
            case "sales":
                return (
                    <Chart {...commonProps} ref={saleRef}>
                        <ChartTitle text={title} font="22Pt bold" color="#00008B" />
                        <ChartLegend position="top" orientation="horizontal" />
                        <ChartCategoryAxis>
                            <ChartCategoryAxisItem categories={labels} startAngle={45} />
                        </ChartCategoryAxis>
                        <ChartValueAxis>
                            <ChartValueAxisItem title={{ text: salesYAxis }} />
                        </ChartValueAxis>
                        <ChartSeriesDefaults type="line" />
                        <ChartSeries>
                            {sales.map((item, idx) => (
                                <ChartSeriesItem
                                    key={idx}
                                    type="line"
                                    tooltip={{ visible: true }}
                                    data={item.data}
                                    name={item.name}
                                />
                            ))}
                        </ChartSeries>
                    </Chart>
                );
            case "product":
                return (
                    <Chart {...commonProps} ref={productRef}>
                        <ChartTitle text="Product Performance (Top 5)" font="22Pt bold" color="#00008B" />
                        <ChartLegend position="top" orientation="horizontal" />
                        <ChartCategoryAxis>
                            <ChartCategoryAxisItem categories={categories} startAngle={45} />
                        </ChartCategoryAxis>
                        <ChartValueAxis>
                            <ChartValueAxisItem title={{ text: productYAxis }} />
                        </ChartValueAxis>
                        <ChartSeriesDefaults type="column" overlay={{ gradient: "sharpBevel" }} gap={0.3} spacing={0.2} />
                        <ChartSeries>
                            {productPerformance.map((item, idx) => (
                                <ChartSeriesItem key={idx} data={item.data} name={item.name} />
                            ))}
                        </ChartSeries>
                    </Chart>
                );
            case "total":
                return (
                    <Chart {...commonProps} ref={totalRef}>
                        <ChartTitle text="Accumulated Total" font="22Pt bold" color="#00008B" />
                        <ChartLegend position="top" orientation="horizontal" />
                        <ChartCategoryAxis>
                            <ChartCategoryAxisItem categories={labels} startAngle={45} />
                        </ChartCategoryAxis>
                        <ChartValueAxis>
                            <ChartValueAxisItem title={{ text: accYAxis }} />
                        </ChartValueAxis>
                        <ChartSeriesDefaults type="area" overlay={{ gradient: "sharpBevel" }} />
                        <ChartSeries>
                            {accumulated.map((item, idx) => (
                                <ChartSeriesItem key={idx} data={item.data} name={item.name} />
                            ))}
                        </ChartSeries>
                    </Chart>
                );
            case "site":
                return (
                    <Chart {...commonProps} ref={siteRef}>
                        <ChartTitle text={siteHeading} font="22Pt bold" color="#00008B" />
                        <ChartLegend position="top" orientation="horizontal" />
                        <ChartSeries>
                            <ChartSeriesItem
                                type="pie"
                                overlay={{ gradient: "sharpBevel" }}
                                tooltip={{ visible: true }}
                                data={pieData}
                                categoryField="name"
                                field="share"
                            />
                        </ChartSeries>
                    </Chart>
                );
            default:
                return null;
        }
    };

    return (
        <>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 16,
                    marginBottom: 16,
                    padding: "0 10px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: 8,
                }}
            >
                {/* Filters - same dropdowns but better spacing & style */}
                <MultiSelect
                    data={loadTypes}
                    value={loadType}
                    onChange={changeHandlers.loadType}
                    placeholder="Load Type"
                    style={{ minWidth: 180, flex: "1 1 150px" }}
                    filterable
                />
                <MultiSelect
                    data={vehicleTypes}
                    value={vehicleType}
                    onChange={changeHandlers.vehicleType}
                    placeholder="Vehicle Type"
                    style={{ minWidth: 180, flex: "1 1 150px" }}
                    filterable
                    textField="name"
                    dataItemKey="id"
                />
                <MultiSelect
                    data={jobdata}
                    value={job}
                    onFilterChange={filterjobChange}
                    filterable={true}
                    onChange={changeHandlers.job}
                    placeholder="Job"
                    style={{ minWidth: 180, flex: "1 1 150px" }}
                    filterable
                    textField="name"
                    dataItemKey="id"
                />
                <MultiSelect
                    data={customerdata}
                    value={customer}
                    onFilterChange={filtercustChange}
                    filterable={true}
                    onChange={changeHandlers.customer}
                    placeholder="Customer"
                    style={{ minWidth: 180, flex: "1 1 150px" }}
                    filterable
                    textField="name"
                    dataItemKey="id"
                />
                <MultiSelect
                    data={srcdata}
                    value={source}
                    onFilterChange={filtersrcChange}
                    filterable={true}
                    onChange={changeHandlers.source}
                    placeholder="Source"
                    style={{ minWidth: 180, flex: "1 1 150px" }}
                    filterable
                    textField="name"
                    dataItemKey="id"
                />
                <MultiSelect
                    data={destdata}
                    value={destination}
                    onFilterChange={filterdestChange}
                    filterable={true}
                    onChange={changeHandlers.destination}
                    placeholder="Destination"
                    style={{ minWidth: 180, flex: "1 1 150px" }}
                    filterable
                    textField="name"
                    dataItemKey="id"
                />
                <MultiSelect
                    data={sites}
                    value={site}
                    onChange={changeHandlers.site}
                    placeholder="Site"
                    style={{ minWidth: 180, flex: "1 1 150px" }}
                    filterable
                    textField="name"
                    dataItemKey="id"
                />
                <MultiSelect
                    data={productdata}
                    value={product}
                    onFilterChange={filterprodChange}
                    filterable={true}
                    onChange={changeHandlers.product}
                    placeholder="Product"
                    style={{ minWidth: 180, flex: "1 1 150px" }}
                    filterable
                    textField="name"
                    dataItemKey="id"
                />
                <MultiSelect
                    data={directions}
                    value={direction}
                    onChange={changeHandlers.direction}
                    placeholder="Direction"
                    style={{ minWidth: 180, flex: "1 1 150px" }}
                    filterable
                />

                <button
                    onClick={DoSearch}
                    className="k-button k-primary"
                    style={{ marginLeft: 8, height: 38 }}
                >
                    Apply
                </button>
                <button
                    onClick={ClearSearch}
                    className="k-button"
                    style={{ height: 38 }}
                >
                    Clear
                </button>
            </div>

            <div className="row" style={{ padding: "5px 10px" }}></div>

            <div className="row mb-3">
                {sales && (
                    <div className="col-6 mb-4">
                        <ButtonsGroup
                            exportName="sales"
                            onExportClick={onImageExportClick}
                            onZoomClick={() => setModalChart("sales")}
                        />
                        <div className="k-card" style={cardStyle3D}>
                            <Chart
                                ref={saleRef}
                                style={{
                                    height: 350,
                                    filter: "drop-shadow(0 0 5px rgba(0, 0, 0, 0.15))",
                                    borderRadius: "10px",
                                }}
                            >
                                <ChartTitle text={title} font="22Pt bold" color="#00008B" />
                                <ChartLegend position="top" orientation="horizontal" />
                                <ChartCategoryAxis>
                                    <ChartCategoryAxisItem categories={labels} startAngle={45} />
                                </ChartCategoryAxis>
                                <ChartValueAxis>
                                    <ChartValueAxisItem title={{ text: salesYAxis }} />
                                </ChartValueAxis>
                                <ChartSeriesDefaults type="line" />
                                <ChartSeries>
                                    {sales.map((item, idx) => (
                                        <ChartSeriesItem
                                            key={idx}
                                            type="line"
                                            tooltip={{ visible: true }}
                                            data={item.data}
                                            name={item.name}
                                        />
                                    ))}
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>
                )}

                {productPerformance && (
                    <div className="col-6 mb-4">
                        <ButtonsGroup
                            exportName="product"
                            onExportClick={onImageExportClick}
                            onZoomClick={() => setModalChart("product")}
                        />
                        <div className="k-card" style={cardStyle3D}>
                            <Chart
                                ref={productRef}
                                style={{
                                    height: 350,
                                    filter: "drop-shadow(0 0 5px rgba(0, 0, 0, 0.15))",
                                    borderRadius: "10px",
                                }}
                            >
                                <ChartTitle
                                    text="Product Performance (Top 5)"
                                    font="22Pt bold"
                                    color="#00008B"
                                />
                                <ChartLegend position="top" orientation="horizontal" />
                                <ChartCategoryAxis>
                                    <ChartCategoryAxisItem categories={categories} startAngle={45} />
                                </ChartCategoryAxis>
                                <ChartValueAxis>
                                    <ChartValueAxisItem title={{ text: productYAxis }} />
                                </ChartValueAxis>
                                <ChartSeriesDefaults
                                    type="column"
                                    overlay={{ gradient: "sharpBevel" }}
                                    gap={0.3}
                                    spacing={0.2}
                                />
                                <ChartSeries>
                                    {productPerformance.map((item, idx) => (
                                        <ChartSeriesItem key={idx} data={item.data} name={item.name} />
                                    ))}
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>
                )}
            </div>

            <div className="row">
                {accumulated && (
                    <div className="col-6 mb-4">
                        <ButtonsGroup
                            exportName="total"
                            onExportClick={onImageExportClick}
                            onZoomClick={() => setModalChart("total")}
                        />
                        <div className="k-card" style={cardStyle3D}>
                            <Chart
                                ref={totalRef}
                                style={{
                                    height: 350,
                                    filter: "drop-shadow(0 0 5px rgba(0, 0, 0, 0.15))",
                                    borderRadius: "10px",
                                }}
                            >
                                <ChartTitle text="Accumulated Total" font="22Pt bold" color="#00008B" />
                                <ChartLegend position="top" orientation="horizontal" />
                                <ChartCategoryAxis>
                                    <ChartCategoryAxisItem categories={labels} startAngle={45} />
                                </ChartCategoryAxis>
                                <ChartValueAxis>
                                    <ChartValueAxisItem title={{ text: accYAxis }} />
                                </ChartValueAxis>
                                <ChartSeriesDefaults type="area" overlay={{ gradient: "sharpBevel" }} />
                                <ChartSeries>
                                    {accumulated.map((item, idx) => (
                                        <ChartSeriesItem key={idx} data={item.data} name={item.name} />
                                    ))}
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>
                )}

                {pieData && (
                    <div className="col-6 mb-4">
                        <ButtonsGroup
                            exportName="site"
                            onExportClick={onImageExportClick}
                            onZoomClick={() => setModalChart("site")}
                        />
                        <div className="k-card" style={cardStyle3D}>
                            <Chart
                                ref={siteRef}
                                style={{
                                    height: 350,
                                    filter: "drop-shadow(0 0 5px rgba(0, 0, 0, 0.15))",
                                    borderRadius: "10px",
                                }}
                            >
                                <ChartTitle text={siteHeading} font="22Pt bold" color="#00008B" />
                                <ChartLegend position="top" orientation="horizontal" />
                                <ChartSeries>
                                    <ChartSeriesItem
                                        type="pie"
                                        overlay={{ gradient: "sharpBevel" }}
                                        tooltip={{ visible: true }}
                                        data={pieData}
                                        categoryField="name"
                                        field="share"
                                    />
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>
                )}
            </div>

            {modalChart &&
                ReactDOM.createPortal(
                    <div
                        style={modalStyles.overlay}
                        onClick={() => setModalChart(null)}
                        role="dialog"
                        aria-modal="true"
                    >
                        <div style={modalStyles.content} onClick={(e) => e.stopPropagation()}>
                            <button
                                style={modalStyles.closeBtnTopRight}
                                aria-label="Close zoom modal"
                                onClick={() => setModalChart(null)}
                            >
                                &times;
                            </button>
                            {renderModalChart()}
                            <button style={modalStyles.closeBtnBottom} onClick={() => setModalChart(null)}>
                                Close
                            </button>
                        </div>
                    </div>,
                    document.body
                )}
        </>
    );
};

export default PerformanceTrend;
